import React from 'react';
import { ModalContent } from 'fronton-react';
import { ModalHeader, Typography } from 'common/components';
import {
  cabinetBenefitsModalContent,
  cabinetBenefitsModalText,
  cabinetBenefitsModalTitle,
} from '../../cabinet-benefits-styles';

export const Deadline = () => (
  <>
    <ModalHeader className={cabinetBenefitsModalTitle} title="Срок изготовления 21&nbsp;день" />
    <ModalContent className={cabinetBenefitsModalContent}>
      <Typography className={cabinetBenefitsModalText} variant="m" size="body_long">
        Мы&nbsp;ценим ваше время и&nbsp;стремимся обеспечить максимально быстрый и&nbsp;качественный сервис. В&nbsp;течение трех недель мы&nbsp;проведем все этапы&nbsp;&mdash; от&nbsp;разработки дизайна до&nbsp;финальной сборки, чтобы вы&nbsp;могли наслаждаться новым шкафом в&nbsp;кратчайшие сроки.
      </Typography>
    </ModalContent>
  </>
);
